/** Dashboard global search — wired to GET /api/dashboard/search. */
export const DASHBOARD_SEARCH_API_PATH = '/api/dashboard/search'
/** Minimum characters before calling the search API. */
export const DASHBOARD_SEARCH_Q_MIN = 3
/** Default `per_type` query param (backend allows 1–25). */
export const DASHBOARD_SEARCH_PER_TYPE_DEFAULT = 10
